// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___f28x","type":"styles_type__HnuVP","choices":"styles_choices__1bqWv"};